<template lang="pug">
  .set-password
    .set-password-form
      .site-logo
        span.site-name {{ $t('property_list_page.rent_assessment_system') }}
      .password-form
        .password
          p {{ $t('set_password.password') }}
          input(v-model="password" type="password")
        .password-confirm
          p {{ $t('set_password.password_confirm') }}
          input(v-model="passwordConfirm" type="password")

        .errors(v-if="!isEmpty(errors)")
          p {{ errors }}
        .submit
          b-button(variant="primary" @click="setPassword") {{ $t('set_password.set_password') }}
</template>

<script>
  import { api } from '@/api'
  import { isEmpty } from 'lodash'
  import redirectLoggedUser from '@/mixins/redirect-logged-user'
  import toastsMixin from '@/mixins/toasts'

  export default {
    mixins: [
      redirectLoggedUser,
      toastsMixin
    ],

    data() {
      return {
        password: '',
        passwordConfirm: '',
        token: this.$route.query.token,
        errors: '',
        tokenConfirm: undefined
      }
    },

    computed: {
      passwordsTheSame() {
        return this.password == this.passwordConfirm
      },

      passwordMore8Sym() {
        return this.password.length >= 8
      },

      passwordIsNoEmpty() {
        return !isEmpty(this.password) && !isEmpty(this.passwordConfirm)
      },

      passwordIsValid() {
        return this.errors == ''
      },

      validateConditions() {
        return [
          {
            condition: this.passwordMore8Sym, 
            error: this.$t('set_password.password_more_8_symbols')
          },
          {
            condition: this.passwordIsNoEmpty,
            error: this.$t('set_password.fill_these_fields')
          },
          {
            condition: this.passwordsTheSame,
            error: this.$t('set_password.passwords_does_not_match')
          }
        ]
      },

      checkTokenUrl() {
        return '/passwords/check_token'
      },

      setPasswordUrl() {
        return '/passwords'
      }
    },

    mounted() {
      if (isEmpty(this.token)) {
        this.redirectToLoginPage()
      } else {
        this.checkTokenInDataBase()
      }
    },

    methods: {
      isEmpty, 

      setPassword() {
        this.validatePassword()
        if (this.passwordIsValid) {
          const params = { password: this.password, password_confirm: this.passwordConfirm, token: this.token }
          api.post(this.setPasswordUrl, params).then(() => {
            this.$bvToast.show('set-password-notification')
            this.redirectToLoginPage()
          }).catch(() => {
            this.$bvToast.show('set-password-error')
            this.redirectToLoginPage()
          })
        }
      },

      validatePassword() {
        this.checkAllConditions()
        this.validateConditions.forEach(({condition, error}) => {
          this.checkCondition(condition, error)
        })
      },

      checkCondition(condition, error) {
        if (!condition) {
          this.errors = error
        }
      },

      checkAllConditions() {
        if (this.passwordsTheSame && this.passwordMore8Sym && this.passwordIsNoEmpty) {
          this.errors = ''
        }
      },

      checkTokenInDataBase() {
        const params = { token: this.token }
        api.post(this.checkTokenUrl, params).catch(({ response: { status, data: { errors: { text } } }}) => {
            status == 404 && this.showToast(this.$t('set_password.token_not_exist'))
            status == 500 && this.showToast(text)
            setTimeout(this.redirectToLoginPage, 1500)
        })
      },

      redirectToLoginPage() {
        this.$router.push({ name: 'LoginPage' })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .set-password {
    background-image: linear-gradient(270deg, rgba(24, 172, 235, 0.98) 0%, #18a4eb 100%);
    display: flex;
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 15;

    .set-password-form {
      margin: auto;

      .site-logo {
        align-items: center;
        display: flex;
        justify-content: center;
        margin-bottom: 20px;

        .logo {
          color: #fff;
          opacity: 0.9;
        }

        .site-name {
          color: #fff;
          font-size: 18px;
          letter-spacing: 0;
        }
      }

      .password-form {
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 4px 16px 0 rgba(176, 186, 197, 0.56);
        padding: 30px;

        input {
          background: #fff;
          border: 1px solid #dfe6ee;
          border-radius: 4px;
        }

        p {
          color: #7c91a7;
          font-size: 13px;
          letter-spacing: 0;
          margin: 0;
          padding: 20px 0 3px 0;
        }

        .submit {
          button {
            background-image: linear-gradient(270deg, rgba(24, 172, 235, 0.98) 0%, #18a4eb 100%);
            border: 0;
            border-radius: 4px;
            margin-top: 20px;
            width: 100%;
          }
        }

        .errors {
          p {
            color: red;
          }
        }
      }
    }
  }
</style>
